export const PermissionAr = {
  "ACHATS": "المشتريات",
  "CATEGORIES": "الفئات",
  "CLIENTS": "الزبناء",
  "DEPENSES": "المصاريف",
  "SERVICE": "خدمة",
  "SERVICES": "الخدمات",
  "FOURNISSEURS": "الموردين",
  "MODE_PAIEMENTS": "طرق الدفع",
  "PAIEMENTS": "المدفوعات",
  "PRODUITS": "المنتجات",
  "ROLES": "الأدوار",
  "STATISTIQUES": "الإحصائيات",
  "UTILISATEURS": "المستخدمين",
  "VENTES": "المبيعات",

  "AFFICHER": "عرض",
  "AJOUTER": "يضيف",
  "MODIFIER": "تعديل",
  "SUPPRIMER": "يمسح",

  "AJOUTER_PAIEMENT": "إضافة الدفع",
  "MODIFIER_PAIEMENT": "تعديل الدفع",
  "SUPPRIMER_PAIEMENT": "حذف الدفع",
  "AFFICHER_LIST": "عرض القائمة",

}

